/*
 *
 * CollaboratorsImport reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_TEMPLATE_COLLABORATORS_WATCHER,
  GET_TEMPLATE_COLLABORATORS_SUCCESS,
  GET_TEMPLATE_COLLABORATORS_FAILED,
  UPLOAD_TEMPLATE_COLLABORATORS_WATCHER,
  UPLOAD_TEMPLATE_COLLABORATORS_SUCCESS,
  UPLOAD_TEMPLATE_COLLABORATORS_FAILED,
  GET_TEMPLATE_CEASED_WATCHER,
  GET_TEMPLATE_CEASED_SUCCESS,
  GET_TEMPLATE_CEASED_FAILED,
  UPLOAD_TEMPLATE_CEASED_WATCHER,
  UPLOAD_TEMPLATE_CEASED_SUCCESS,
  UPLOAD_TEMPLATE_CEASED_FAILED,
  GET_TEMPLATE_TEAMS_WATCHER,
  GET_TEMPLATE_TEAMS_SUCCESS,
  GET_TEMPLATE_TEAMS_FAILED,
  UPLOAD_TEMPLATE_TEAMS_WATCHER,
  UPLOAD_TEMPLATE_TEAMS_SUCCESS,
  UPLOAD_TEMPLATE_TEAMS_FAILED,
} from "./constants"

export const initialState = fromJS({
  isDownloading: false,
  isUploading: false,
})

function collaboratorsImportReducer(state = initialState, action) {
  switch (action.type) {
    case GET_TEMPLATE_COLLABORATORS_WATCHER:
    case GET_TEMPLATE_CEASED_WATCHER:
      return state.set("isDownloading", true)
    case GET_TEMPLATE_TEAMS_WATCHER:
      return state.set("isDownloading", true)
    case GET_TEMPLATE_COLLABORATORS_SUCCESS:
    case GET_TEMPLATE_CEASED_SUCCESS:
      return state.set("isDownloading", false)
    case GET_TEMPLATE_TEAMS_SUCCESS:
      return state.set("isDownloading", false)
    case GET_TEMPLATE_COLLABORATORS_FAILED:
    case GET_TEMPLATE_CEASED_FAILED:
      return state.set("isDownloading", false)
    case GET_TEMPLATE_TEAMS_FAILED:
      return state.set("isDownloading", false)
    case UPLOAD_TEMPLATE_COLLABORATORS_WATCHER:
    case UPLOAD_TEMPLATE_CEASED_WATCHER:
      return state.set("isUploading", true)
    case UPLOAD_TEMPLATE_COLLABORATORS_SUCCESS:
    case UPLOAD_TEMPLATE_CEASED_SUCCESS:
      return state.set("isUploading", false)
    case UPLOAD_TEMPLATE_COLLABORATORS_FAILED:
    case UPLOAD_TEMPLATE_CEASED_FAILED:
      return state.set("isUploading", false)
    case UPLOAD_TEMPLATE_TEAMS_WATCHER:
      return state.set("isUploading", true)
    case UPLOAD_TEMPLATE_TEAMS_SUCCESS:
      return state.set("isUploading", false)
    case UPLOAD_TEMPLATE_TEAMS_FAILED:
      return state.set("isUploading", false)
    default:
      return state
  }
}

export default collaboratorsImportReducer
